import { render, staticRenderFns } from "./footerCom.vue?vue&type=template&id=3b2592fc&scoped=true"
import script from "./footerCom.vue?vue&type=script&lang=ts"
export * from "./footerCom.vue?vue&type=script&lang=ts"
import style0 from "./footerCom.vue?vue&type=style&index=0&id=3b2592fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2592fc",
  null
  
)

export default component.exports